<template>
  <div class="login-container">
    <!--[if lte IE 8]>
    <div>
      <h4>温馨提示：</h4>
      <p>你使用的浏览器版本过低, 为了获得更好的浏览体验, 我们强烈建议您 <a href="http://browsehappy.com" target="_blank">升级</a>
        到最新版本的IE浏览器, 或者使用较新版本的 Chrome、Firefox、Safari 等. </p>
    </div>
    <![endif]-->


    <!-- BACKGROUND IMAGE -->
    <!--===================================================-->
    <div class="login-bg-img login-bg-img-balloon"></div>

    <!-- HEADER -->
    <!--===================================================-->
    <div class="login-header">
      <div class="login-header-title">
        <a>
          <span>{{projectName}}</span>
        </a>
      </div>
    </div>
    <!--===================================================-->

    <!-- LOGIN FORM -->
    <!--===================================================-->
    <div class="login-body">
      <div class="login-body-panel">
        <div class="panel-body" style="padding: 35px 35px 0;">
          <div class="login-tabs">
            <p
              :class="activeTabs == '1' ? 'login-tabs-cell activeTabsClass':'login-tabs-cell'"
              @click="activeTabs = '1'"
            >企业用户</p>
            <p
              :class="activeTabs == '2' ? 'login-tabs-cell activeTabsClass':'login-tabs-cell'"
              @click="activeTabs = '2'"
            >个人用户</p>
          </div>
          <div v-show="activeTabs == '1'">
            <el-form :model="registerOrgData" :rules="rules" ref="registerOrgData" class="demo-ruleForm">
              <el-form-item prop="loginName">
                <el-input v-model="registerOrgData.loginName" placeholder="请输入邮箱"></el-input>
              </el-form-item>
              <el-form-item prop="passwordReplace">
                <el-input v-model="registerOrgData.passwordReplace" type="password"  placeholder="请输入密码"></el-input>
              </el-form-item>
              <el-form-item prop="verifyPasswordReplace">
                <el-input v-model="registerOrgData.verifyPasswordReplace" type="password" placeholder="请再次输入密码"></el-input>
              </el-form-item>
              <el-form-item prop="verifyCode">
                <el-input v-model="registerOrgData.verifyCode" style="width: 60%;float: left;" placeholder="请输入验证码"></el-input>
                <el-button style="float: right;" v-if="codeShow" type="primary" v-loading="disEmailCode" @click="getEmailCode">发送验证码</el-button>
                <el-button type="primary" style="float: right;" disabled v-if="!codeShow">{{codeText}}</el-button>
              </el-form-item>
              <el-form-item>
                <el-checkbox v-model="registerOrgData.checked"></el-checkbox>
                <span>已阅读并同意</span>
                <span class="check" @click="dialogVisible = true">《使用协议》</span>
                <span>及</span>
                <span class="check" @click="dialogVisible1 = true">《隐私政策》</span>
              </el-form-item>
              <el-form-item prop="name">
                <el-button  type="primary" style="width: 100%;" @click="regExternalOrgUser('registerOrgData')">注册</el-button>
              </el-form-item>
              <el-form-item>
                <div>已有账号,<span class="check" @click="$router.back(-1)">立即登录</span></div>
              </el-form-item>
            </el-form>
          </div>
          <div v-show="activeTabs == '2'">
            <el-form :model="registerData" :rules="rules1" ref="registerData" class="demo-ruleForm">
              <el-form-item prop="loginName">
                <el-input v-model="registerData.loginName" placeholder="请输入手机号"></el-input>
              </el-form-item>
              <el-form-item prop="passwordReplace">
                <el-input v-model="registerData.passwordReplace" type="password" placeholder="请输入密码"></el-input>
              </el-form-item>
              <el-form-item prop="verifyPasswordReplace">
                <el-input v-model="registerData.verifyPasswordReplace" type="password" placeholder="请再次输入密码"></el-input>
              </el-form-item>
              <el-form-item prop="verifyCode">
                <el-input v-model="registerData.verifyCode" style="width: 60%;float: left;" placeholder="请输入验证码"></el-input>
                <el-button style="float: right;" v-if="codeShow1" type="primary" @click="getPhoneCode">发送验证码</el-button>
                <el-button type="primary" style="float: right;" disabled v-if="!codeShow1">{{codeText1}}</el-button>
              </el-form-item>
              <el-form-item>
                <el-checkbox v-model="registerData.checked"></el-checkbox>
                <span>已阅读并同意</span>
                <span class="check" @click="dialogVisible = true">《使用协议》</span>
                <span>及</span>
                <span class="check" @click="dialogVisible1 = true">《隐私政策》</span>
              </el-form-item>
              <el-form-item prop="name">
                <el-button  type="primary" style="width: 100%;" @click="regExternalUser('registerData')">注册</el-button>
              </el-form-item>
              <el-form-item>
                <div>已有账号,<span class="check" @click="$router.back(-1)">立即登录</span></div>
              </el-form-item>
            </el-form>
          </div>
          <el-dialog
            :title="useProtocolData.title"
            :visible.sync="dialogVisible"
            width="50%"
            :before-close="handleClose">
            <div style="text-align: left;text-indent:28px">
              <p class="protocolFont protocolFontW"  v-html="useProtocolData.subtitle"></p>
              <p class="protocolFont protocolFontW"  v-html="useProtocolData.subtitle1"></p>
              <p class="protocolFont protocolFontW"  v-html="useProtocolData.subtitle2"></p>
              <p class="protocolFont protocolFontW"  v-html="useProtocolData.subtitle3"></p>
            </div>
            <div v-for="(item,index) in useProtocolData.children" :key="index" style="text-align: left;text-indent:28px">
              <p class="protocolFont protocolFontW" v-html="item.title"></p>
              <p class="protocolFont" v-for="(data,index2) in item.text" :key="index2">
                {{data}}
              </p>
            </div>
            <span slot="footer" class="dialog-footer">
              <el-button @click="dialogVisible = false">取 消</el-button>
              <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
            </span>
          </el-dialog>
          <el-dialog
            :title="privacyPolicyData.title"
            :visible.sync="dialogVisible1"
            width="50%"
            :before-close="handleClose">
            <div style="text-align: left;text-indent:28px">
              <p class="protocolFont protocolFontW"  v-html="privacyPolicyData.subtitle"></p>
            </div>
            <div v-for="(item,index) in privacyPolicyData.children" :key="index" style="text-align: left;text-indent:28px">
              <p class="protocolFont protocolFontW" v-html="item.title"></p>
              <p class="protocolFont" v-for="(data,index2) in item.text" :key="index2">
                {{data}}
              </p>
            </div>
            <span slot="footer" class="dialog-footer">
              <el-button @click="dialogVisible1 = false">取 消</el-button>
              <el-button type="primary" @click="dialogVisible1 = false">确 定</el-button>
            </span>
          </el-dialog>
        </div>
      </div>
    </div>
  </div>
</template>

<script  type="text/babel">
  import api from "@/assets/js/api";
  import { Decrypt, Encrypt } from "../../assets/js/utils";
  let test = require('../../../static/json/useProtocol')
  let test1 = require('../../../static/json/privacyPolicy')
  export default {
    data() {
      var verifyPasswords  = (rule, value, callback) => {
        if(value == this.registerOrgData.passwordReplace){
          callback();
        }else{
          return callback(new Error("两次输入的密码不一致"));
        }
      };
      var verifyPasswords1 = (rule, value, callback) => {
        if(value == this.registerData.passwordReplace){
          callback();
        }else{
          return callback(new Error("两次输入的密码不一致"));
        }
      };
      return {
        useProtocolData:"",//注册须知
        privacyPolicyData:"",//隐私政策
        disEmailCode:false,
        activeTabs:"1",
        projectName: "",
        dialogVisible:false,
        dialogVisible1:false,
        registerOrgData:{
          "loginName": "",
          "password": "",
          "passwordReplace":"",
          "verifyPassword": "",
          "verifyPasswordReplace":"",
          "verifyCode": "",
          "checked":""
        },
        rules:{
          loginName:[
            { required: true, message: '请输入邮箱', trigger: 'blur' },
          ],
          passwordReplace:[
            { required: true, message: '请输入密码', trigger: 'blur' },
            { pattern: /^(?![^a-zA-Z]+$)(?!\D+$).{8,16}/,trigger:'change',message:"8-16位密码,由数字和字母组合(区分大小写)"}
          ],
          verifyPasswordReplace:[
            { required: true, message: '请再次输入密码', trigger: 'blur' },
            { validator: verifyPasswords, trigger: "change" }
          ],
          verifyCode:[
            { required: true, message: '请输入验证码', trigger: 'blur' },
          ],
        },
        rules1:{
          loginName:[
            { required: true, message: '请输入手机号', trigger: 'blur' },
          ],
          passwordReplace:[
            { required: true, message: '请输入密码', trigger: 'blur' },
            { pattern: /^(?![^a-zA-Z]+$)(?!\D+$).{8,16}/,trigger:'change',message:"8-16位密码,由数字和字母组合(区分大小写)"}
          ],
          verifyPasswordReplace:[
            { required: true, message: '请再次输入密码', trigger: 'blur' },
            { validator: verifyPasswords1, trigger: "change" }
          ],
          verifyCode:[
            { required: true, message: '请输入验证码', trigger: 'blur' },
          ],
        },
        registerData:{
          "loginName": "",
          "password": "",
          "passwordReplace":"",
          "verifyPassword": "",
          "verifyPasswordReplace":"",
          "verifyCode": "",
          "checked":""
        },
        s:60,
        codeText:"60s后重新发送",
        codeShow:true,
        s1:60,
        codeText1:"60s后重新发送",
        codeShow1:true,
      };
    },
    watch: {
      activeTabs: function() {
        if (this.activeTabs == "1") {


        } else {

        }
      }
    },
    mounted(){
      api.menu.getProjectName().then(res => {
        this.projectName = res.data.data.projectName;
      });
      var _this = this;
      this.useProtocolData = test;
      this.privacyPolicyData = test1
      /*$.ajax({
        type:"get",
        url:"../../../static/json/useProtocol.json",
        success:function (res) {
          // console.log(res,"请求一下");
          _this.useProtocolData = res;
        },
        error:function (err) {
          console.log(err);
        }
      })*/
      //privacyPolicy
      /*$.ajax({
        type:"get",
        url:"../../../static/json/privacyPolicy.json",
        success:function (res) {
          console.log(res,"请求一下");
          _this.privacyPolicyData = res;
        },
        error:function (err) {
          console.log(err);
        }
      })*/
    },
    methods: {
      handleClose(done){
        done();
      },
      //获取邮箱验证码
      getEmailCode(){
        this.disEmailCode = true;
        var regEmail = /^[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*@[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*\.[a-z]{2,}$/;
        if(!regEmail.test(this.registerOrgData.loginName)){
          this.$message.warning("请输入正确格式的邮箱!");
          this.disEmailCode = false;
          return false
        }
        let params = {
          "mobileOrEmail":this.registerOrgData.loginName
        }
        var _this = this;
        _this.s = 60;
        let check = new Promise((resolve,reject) => {
          api.menu.checkLoginNameIsExists({loginName:_this.registerOrgData.loginName}).then(res=>{
            if(res.data.code == '0'){
              resolve(res);
            }else{
              reject(res);
            }
          })
        })
        check.then(res1=>{
          api.menu.sendMobileOrEmailCode(params).then(res=>{
            this.disEmailCode = false;
            if(res.data.code == '0'){
              _this.codeShow = false;
              let times = setInterval(function () {
                _this.s--;
                _this.codeText = _this.s+"s后重新发送";
                if(_this.s == 0) {
                  clearInterval(times)
                  _this.codeText="60s后重新发送";
                  _this.codeShow = true;
                }
              },1000)
            }else{
              this.$message.error(res.data.message)
            }
          })
        }).catch(err=>{
          this.disEmailCode = false;
          this.$message.error(err.data.message)
        })

      },
      //获取短信验证码
      getPhoneCode(){
        var reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
        if(!reg.test(this.registerData.loginName)){
          this.$message.warning("请输入手机号")
          return false
        }
        let params = {
          "mobileOrEmail":this.registerData.loginName
        }
        var _this = this;
        _this.s1 = 60;
        let check = new Promise((resolve,reject) => {
          api.menu.checkLoginNameIsExists({loginName:_this.registerData.loginName}).then(res=>{
            if(res.data.code == '0'){
              resolve(res);
            }else{
              reject(res);
            }
          })
        })
        check.then(res1=>{
          api.menu.sendMobileOrEmailCode(params).then(res=>{
            if(res.data.code == '0'){
              _this.codeShow1 = false;
              let times = setInterval(function () {
                _this.s1--;
                _this.codeText1 = _this.s1+"s后重新发送";
                if(_this.s1 == 0) {
                  clearInterval(times)
                  _this.codeText1 = "60s后重新发送";
                  _this.codeShow1 = true;
                }
              },1000)
            }else{
              this.$message.error(res.data.message)
            }
          })
        }).catch(err=>{
          this.$message.error(err.data.message)
        })

      },

      //企业注册
      regExternalOrgUser(formName) {
        if(!this.registerOrgData.checked){
          this.$message.warning("请阅读《使用协议》及《隐私政策》");
          return false
        }
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let params = {
              "loginName": this.registerOrgData.loginName,
              "password": Encrypt(this.registerOrgData.passwordReplace, sessionStorage.getItem("aesKey")),
              "verifyPassword":Encrypt(this.registerOrgData.verifyPasswordReplace, sessionStorage.getItem("aesKey")),
              "verifyCode": this.registerOrgData.verifyCode,
            }
            api.menu.regExternalOrgUser(params).then(res=>{
              // console.log(res,"企业注册");
              if(res.data.code == '0'){
                this.$message.success(res.data.message);
                this.$router.push('/login')
              }else{
                this.$message.error(res.data.message);
              }
            })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },

      //个人注册
      regExternalUser(formName){
        if(!this.registerData.checked){
          this.$message.warning("请阅读《使用协议》及《隐私政策》");
          return false
        }
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let params = {
              "loginName": this.registerData.loginName,
              "password": Encrypt(this.registerData.passwordReplace, sessionStorage.getItem("aesKey")),
              "verifyPassword":Encrypt(this.registerData.verifyPasswordReplace, sessionStorage.getItem("aesKey")),
              "verifyCode": this.registerData.verifyCode,
            }
            api.menu.regExternalUser(params).then(res=>{
              // console.log(res,"个人注册");
              if(res.data.code == '0'){
                this.$message.success(res.data.message);
                this.$router.push('/login')
              }else{
                this.$message.error(res.data.message);
              }
            })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
    }

  };
</script>

<style scoped>
  .protocolFont{
    font-size: 14px;
    margin: 5px 0;
  }
  .protocolFontW{
    font-weight: bold;
  }
  input:-webkit-autofill {
    -webkit-box-shadow: 0 0 0 1000px #fff inset !important;
    -webkit-text-fill-color: rgba(85, 85, 85, 1) !important;
  }

  /* 登录 Start */
  login-container .btn-primary {
    background: #237bdf;
  }

  login-container .btn-primary:active:hover {
    background: #237bdf;
    box-shadow: none;
  }

  login-container .btn-primary:hover,
  .btn-primary:active {
    background: #237bdf;
  }

  login-container .form-control:active:hover:focus {
    border: 1px solid #ccc !important;
  }

  .login-container {
    background-color: #212124;
    color: #515151;
    text-align: center;
    font-size: 12px;
    padding: 0;
    vertical-align: middle;
    width: auto;
    min-height: 100vh;
  }

  .login-bg-img {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    opacity: 0.8;
    background: no-repeat fixed center center;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
  }

  /*背景图片*/
  .login-bg-img-balloon {
    background-image: url("../../../static/img/bg-img-6.jpg");
  }

  .login-header {
    position: relative;
    /*background-color: rgba(0, 0, 0, 0.1);*/
    font-weight: 400;
    font-size: 30px;
    padding: 50px 0 30px;
  }

  .login-header .login-header-title .brand-icon {
    width: 60px;
    height: 60px;
  }

  .cls-container .login-header .login-header .login-header-title .brand-title {
    font-size: 27px;
  }

  .login-header-title {
    display: inline-block;
    padding: 20px 0;
    font-size: 32px;
    line-height: 60px;
  }

  .login-header-title a {
    letter-spacing: 10px;
    color: #ffffff;
  }

  .login-header-title a:hover {
    color: #ffffff;
  }

  .login-body {
    padding: 15px 15px;
    position: relative;
    margin-left: 5px;
    margin-right: 5px;
  }

  .login-body-panel {
    width: 70%;
    min-width: 250px;
    max-width: 450px;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 20px;
    background-color: #fff;
    border: 1px solid transparent;
    border-radius: 4px;
    -webkit-box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
  }

  .login-body-panel .panel-body {
    padding: 35px;
  }

  .login-body-panel-head {
    margin-bottom: 20px;
    /*margin-left: 50px;*/
    font-size: 22px;
    color: #237bdf;
    letter-spacing: 2px;
    text-align: center;
  }

  .login-footer {
    font-size: 15px;
    padding-bottom: 10px;
    color: #e0e0e0;
  }

  .login-footer a {
    color: #e0e0e0;
  }

  .login-footer a:hover {
    color: #ffffff;
  }

  .login-mar-rgt {
    margin-right: 15px;
  }

  .login-mar-lft {
    margin-left: 15px;
  }

  .input-group .input-group-addon {
    border-radius: 4px 0 0 4px;
  }

  .form-control {
    border-radius: 4px;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    position: relative;
    z-index: 2;
    float: left;
    width: 100%;
    margin-bottom: 0;
  }

  .login-icon {
    padding-left: 18px;
    padding-right: 18px;
    border-radius: 4px;
  }

  .verify-code {
    margin-bottom: 10px;
  }

  .login-user-img {
    background-image: url("../../../static/img/lnavha_pic.png");
    height: 80px;
    width: 80px;
    background-size: 80px;
    margin: 10px auto;
  }
  #login {
    text-align: center;
    display: inline-block;
    width: 100%;
  }
  #login1 {
    text-align: center;
    display: inline-block;
    width: 100%;
  }
  #footer {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    margin: 0 auto;
  }
  /*登录 End */

  /* 切换登录方式 */
  .login-tabs {
    display: flex;
    justify-content: center;
    width: 100%;
    margin-bottom: 20px;
  }
  .login-tabs .login-tabs-cell {
    border-bottom: 3px solid #868686;
    width: 50%;
    padding-bottom: 20px;
    padding-top: 20px;
    font-size: 18px;
    color: #606266;
    letter-spacing: 2px;
    cursor: pointer;
  }
  .activeTabsClass {
    border-bottom: 3px solid #3399ff !important;
  }
  .minLink {
    color: #868686;
    font-size: 14px;
  }
  .minLink > div {
    display: inline-block;
    float: left;
    cursor: pointer;
  }
  .minLink > div:hover {
    color: #3399ff;
  }
  .code {
    display: inline-block;
    width: 32%;
    height: 40px;
    line-height: 40px;
    color: #fff;
    background-color: #409eff;
    border-color: #409eff;
    border-radius: 4px;
  }
  .check{
    color: #3399ff;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/login/register.vue